import { createI18n } from "vue-i18n";
import vi from '@/locales/vi.json'
import en from '@/locales/en.json'
import fr from '@/locales/fr.json'
import es from '@/locales/es.json'
import {ref} from "vue";

const language = localStorage.getItem('language') || currentLanguage();

const i18n = createI18n({
    legacy: false,
    locale: language,
    fallbackLocale: 'vi',
    messages: { vi, en, fr, es }
})

function currentLanguage() {
    let defaultLanguage = ['vi', 'en', 'fr', 'es']
    let lang = navigator.language.split("-")[0];
    console.log(lang);
    let language = defaultLanguage.includes(lang) ? lang : 'en';
    localStorage.setItem('language', language);
    return language;
}

const currentLocale = ref(language);

export { i18n, currentLocale };